<template>
  <section class="high-growth-section">
    <div class="container">
      <div class="growth-card">
        <div class="icon-badge">
          <i class="el-icon-medal"></i>
        </div>
        <h2 class="growth-title">{{ $t('growth.title') }}</h2>
        <div class="growth-divider"></div>
        <div class="growth-content-wrapper">
          <p v-for="(p, index) in formattedContent" :key="index" class="growth-text">
            {{ p }}
          </p>
        </div>
        <div class="growth-footer">
          <div class="growth-tag">{{ $t('growth.tags.innovation') }}</div>
          <div class="growth-tag">{{ $t('growth.tags.excellence') }}</div>
          <div class="growth-tag">{{ $t('growth.tags.global') }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HighGrowth',
  computed: {
    formattedContent() {
      const content = this.$t('growth.content');
      // Split by double newline to handle paragraphs
      return content.split('\n\n');
    }
  }
}
</script>

<style lang="scss" scoped>
.high-growth-section {
  padding: 80px 0;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: -50px;
    right: -50px;
    width: 200px;
    height: 200px;
    background: radial-gradient(circle, rgba(99, 102, 241, 0.05) 0%, transparent 70%);
    border-radius: 50%;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -80px;
    left: -80px;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, rgba(99, 102, 241, 0.03) 0%, transparent 70%);
    border-radius: 50%;
  }
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 24px;
}

.growth-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 48px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.03), 0 1px 3px rgba(0,0,0,0.02);
  border: 1px solid rgba(226, 232, 240, 0.8);
  text-align: center;
  position: relative;
  transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  z-index: 10;

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 30px 60px rgba(99, 102, 241, 0.1);
  }
}

.icon-badge {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #6366f1, #4f46e5);
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 24px;
  box-shadow: 0 10px 15px rgba(99, 102, 241, 0.2);

  i {
    font-size: 32px;
    color: #ffffff;
  }
}

.growth-title {
  font-size: 36px;
  font-weight: 800;
  color: #1e293b;
  margin-bottom: 20px;
  letter-spacing: -0.025em;
  line-height: 1.2;

  @media (max-width: 768px) {
    font-size: 26px;
  }
}

.growth-divider {
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #6366f1, #a5b4fc);
  margin: 0 auto 32px;
  border-radius: 2px;
}

.growth-content-wrapper {
  max-width: 800px;
  margin: 0 auto;
}

.growth-text {
  font-size: 18px;
  line-height: 1.8;
  color: #475569;
  text-align: left;
  margin-bottom: 24px;
  
  &:last-child {
    margin-bottom: 0;
    font-weight: 600;
    color: #4f46e5;
    padding-top: 24px;
    border-top: 1px solid #f1f5f9;
    text-align: center;
    font-style: italic;
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }
}

.growth-footer {
  margin-top: 48px;
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.growth-tag {
  padding: 8px 20px;
  background: #f8fafc;
  color: #6366f1;
  border: 1px solid #eef2ff;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition: all 0.3s;

  &:hover {
    background: #6366f1;
    color: #ffffff;
    border-color: #6366f1;
  }
}
</style>
